<template>
  <div class="dev-commissioner" id="devCommissioner">
    <div class="opreationBox clearfix">
      <div class="fl" style="width: calc(100% - 200px);">
        <el-form
          :inline="true"
          :model="params"
          class="demo-form-inline"
          label-width="130px"
          @submit.native.prevent
        >
          <!--<el-form-item label="发展专员编号">
            <el-input placeholder="请输入" clearable v-model="params.code" />
          </el-form-item>-->
          <el-form-item label="发展专员姓名">
            <el-input placeholder="请输入" clearable v-model="params.name" />
          </el-form-item>
          <el-form-item label="发展专员生效状态">
            <el-select
              clearable
              placeholder="全部"
              v-model="params.state"
            >
              <el-option
                v-for="item in stateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button style="width:98px" type="primary" @click="search">查 询</el-button>
            <el-button style="width:98px" type="danger" plain @click="reset">重 置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="fr" style="width: 200px;text-align: center;">
        <el-button plain type="primary" @click="download(1, '专员月度综合业绩表')">专员月度综合业绩表</el-button>
      </div>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="data"
        border
        style="width: 100%"
      >
<!--        <el-table-column header-align="center" min-width="110" align="center" prop="code" label="发展专员编号"/>-->
        <el-table-column header-align="center" min-width="110" align="center" prop="name" label="发展专员姓名"/>
        <el-table-column header-align="center" min-width="110" align="center" prop="phoneNumber" label="手机号"/>
        <el-table-column header-align="center" min-width="110" align="center" prop="department" label="部门"/>
        <el-table-column header-align="center" min-width="160" align="center" prop="createTime" label="加盟日期"/>
        <el-table-column header-align="center" min-width="60" align="center" prop="state" label="状态">
          <template slot-scope="scope">
            {{ scope.row.state === 0 ? '有效' : ( scope.row.state === 1 ? '无效' : '') }}
          </template>
        </el-table-column>
        <el-table-column header-align="center" min-width="120" align="center" prop="enterpriseCount" label="战略合伙人数量"/>
        <el-table-column header-align="center" min-width="120" align="center" prop="partnerCount" label="二级合伙人数量"/>
        <el-table-column header-align="center" min-width="100" align="center" prop="panelCount" label="会员数量"/>
        <el-table-column header-align="center" min-width="110" align="center" prop="panelFocusCount" label="会员关注数量"/>
        <el-table-column header-align="center" min-width="150" align="center" fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button plain size="mini" style="margin-bottom: 10px;" @click="look(scope.row)">详情</el-button>
            <el-button plain size="mini" type="primary" style="margin-bottom: 10px;" @click="download(2, '专员月度业绩表', scope.row)">专员月度业绩表</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox" style="margin-top: 10px;width: 100%;text-align: right;">
      <el-pagination
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="params.pageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <downloadDialog ref="downloadDialog" />
  </div>
</template>

<script>
  import {SetTableH} from "../../../utils/utils"
  import { getDevManagerList as getList, managerAdministrationDownloadPerformances, managerAdministrationDownloadPerformance } from 'api/request'
  import downloadDialog from "@/components/downloadDialog"
  export default {
    name: 'DevCommissioner',
    components: {
      downloadDialog
    },
    data() {
      return {
        loading: false,
        tableH: '250',
        data: [],
        params: {
          isDeveloper: true,
          pageIndex: 1,
          pageSize: 10,
          code: undefined,
          name: undefined,
          state: undefined
        },
        stateList: [
          { value: '0', label: '有效' },
          { value: '1', label: '无效' }
        ],
        total: 0
      }
    },
    created() {
      this.getList()
    },
    methods: {
      async getList() {
        this.loading = true
        const res = await getList(this.params)
        if (res) {
          const { rows, total } = res
          this.data = Array.isArray(rows) ? rows : []
          this.total = total && total > 0 ? total : 0
        }
        this.loading = false
      },
      look(row) {
        const { id } = row
        this.$router.push({ path: '/agent/devCommissionerDetail', query: { id }})
      },
      sizeChange(val) {
        this.params.pageSize = val
        this.getList()
      },
      currentChange(val) {
        this.params.pageIndex = val
        this.getList()
      },
      search() {
        this.params.pageIndex = 1
        this.getList()
      },
      reset() {
        Object.assign(this.$data.params, this.$options.data().params)
        this.getList()
      },
      download(type, fileName, data) {
        if (type === 1) {
          this.$refs.downloadDialog.show({ api: managerAdministrationDownloadPerformances, apiQueryStr: undefined, title: fileName })
        }
        if (type === 2) {
          const { id } = data
          const downloadParams = { developerId: id }
          const apiQueryStr = Object.keys(downloadParams).map(v => `&${v}=${downloadParams[v]}`).join('')
          this.$refs.downloadDialog.show({ api: managerAdministrationDownloadPerformance, apiQueryStr, title: fileName })
        }
      }
    },
    mounted() {
      SetTableH(this)
    },
  }
</script>

<style scoped lang="scss">
  .dev-commissioner{
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
  }
</style>
